import React, {FC} from "react";
import {Space} from "antd";
import ImportCollectionAuthorizationBtn from "./importCollectionAuthorizationBtn";
import ImportExpectedDeliveryDate from "./importExpectedDeliveryDate";
import ImportPickupAgreementBtn from "./importPickupAgreementBtn";
import DividerLine from "../../../../components/lineSplit";
import ImportPickupOrderBtn from "./importPickupOrderBtn";
import {
  downloadEntryCertificate,
  updateEntryCertificateSigned,
  updatePickupSelf,
  updateTransportOrdered
} from "../../../../services/importService";
import _t from "../../../../lang/translate";
import StatusFlagToggle from "./statusFlagToggle";
import DownloadBtn from "../downloadBtn";

const ImportTransportActions: FC = () => {
  return (
    <>
      <StatusFlagToggle
        color={"default"}
        flag={"pickupSelf"}
        callable={updatePickupSelf}
        label={_t("pickup_self")}
      />
      <DividerLine className="mt-05 mb-1"/>
      <ImportExpectedDeliveryDate/>
      <StatusFlagToggle
        flag={"transportOrdered"}
        callable={updateTransportOrdered}
        label={_t("transport", "ordered")}
      />
      <StatusFlagToggle
        flag={"entryCertificateSigned"}
        callable={updateEntryCertificateSigned}
        label={_t("entry-certificate-GR", "signed")}
      />
      <Space wrap>
        <ImportCollectionAuthorizationBtn/>
        <ImportPickupAgreementBtn/>
        <ImportPickupOrderBtn/>
        <DownloadBtn label={_t("entry-certificate-GR")} callable={downloadEntryCertificate}/>
      </Space>
    </>
  );
};

export default ImportTransportActions;
